import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WorkflowService } from '../services/workflow.service';

export const formGuard: CanActivateFn = (route) => {
  const currentRouteSegments = inject(WorkflowService).currentRoute?.split('/') ?? [];

  const canActivateForm =  currentRouteSegments.length === route.url.length && route.url.every((segment, i) => segment.path === currentRouteSegments[i]);

  return canActivateForm ? canActivateForm : inject(Router).navigate(['/']);
};
